export default function SliderItem()
{
    return (<div className="d-flex basket__slide prod-card swiper-slide">
        <div className="basket__slide-img">
            <picture>
                <source srcSet="images/cat-img.webp" type="image/webp"/>
                <img src="images/cat-img.png" className="d-block h-auto m-auto w-auto" alt="..."/>
            </picture>
        </div>
        <div className="basket__slide-body">
            <div className="prod-card__text prod-card__title t-elips-3">OMP11212 Гайковерт
                пневматический ударный 1/2"DR, 7000 об/мин., 1200 Нм
            </div>
            <div className="d-flex align-items-center basket__slide-bot">
                <div className="d-flex align-items-center flex-wrap m-0 price-row">
                    <p className="prod-card__text fw-medium t-gray text-decoration-line-through">131
                        240₽</p>
                    <p className="prod-card__text fw-bold big t-orange">189 340₽ </p>
                </div>
                <button
                    className="d-flex align-items-center justify-content-center big btn btn-primary prod-card__btn">
                    <div className="btn__img">
                        <img src="images/icon-shop.svg" alt=""/>
                    </div>
                    <span>В корзину</span>
                </button>
            </div>

        </div>
    </div>)
}
